<template>
    <div>
        <v-cookie></v-cookie>
        <div class="place">
            <span>位置：</span>
            <ul class="placeul">
                <li><a href="#">首页</a></li>
                <li>二办记账</li>
                <li><a href="#">记账日志</a></li>
            </ul>
        </div>

        <div class="rightinfo">

            <table class="tablelist">
                <thead>
                    <tr>
                        <th style="width:40%">营业执照</th>
                        <th style="width:15%">税务账号</th>
                        <th style="width:15%">税务密码</th>
                        <th style="width:15%">验证码</th>
                        <th style="width:15%">添加时间</th>
                    </tr>
                </thead>
                <tbody>

                    <tr v-for="(item, index) in dataList" :class="{ odd: index % 2 != 0 }">

                        <td style="width:40%">
                            <template v-if="item.companycodepath.length > 0">
                                <a href="javascript:;" @click="downcompanycodepath(item.id)">下载文件</a>
                                <!-- {{item.voicePath}} -->
                            </template>
                            <!-- <a href="">下载</a> -->
                        </td>
                        <td style="width:15%;">{{ item.taxaccount }}</td>
                        <td style="width:15%">{{ item.taxpwd }}</td>
                        <td style="width:15%">{{ item.smscode }}</td>
                        <td style="width:15%">{{ item.addtime }}</td>
                    </tr>
                </tbody>
            </table>




        </div>
    </div>
</template>
<script>
import cookie from '@/components/cookie.vue'
export default {
    components: {
        'v-cookie': cookie,
    },
    data() {
        return {
            mobile: '',
            month: '',
            content: '',
            pageIndex: 0,
            totalCount: 0,
            dataList: [],
            loadingShow: true,
        }
    },
    mounted() {
        this.pageChange(1);
    },
    methods: {
        handleSizeChange(val) {
            this.pageChange(val);
        },
        handleCurrentChange(val) {
            this.pageChange(val);
        },
        pageChange(pageIndex) {
            this.loadingShow = true;
            let that = this;
            let data = { 'pageIndex': pageIndex, 'pageSize': 50 };
            this.$ajax({
                method: 'post',
                url: this.GLOBAL.serverSrc + '/taxbooks/sendlog.json',
                data: data,
                headers: {
                    'Content-Type': 'application/json; charset=UTF-8',
                    'token': this.GLOBAL.token
                }
            }).then(function (res) {
                console.log(res);
                if ('0000000' == res.data.code) {
                    that.dataList = res.data.Data;
                    that.pageIndex = parseInt(pageIndex);
                    // that.pageCount = res.data.page.pageCount;
                    that.totalCount = res.data.page.totalCount;
                    that.loadingShow = false;
                }
                else {
                    alert(res.data.msg)
                }
            })
        },
        downcompanycodepath(id){
            var url = this.GLOBAL.serverSrc + "/taxbooks/downloadtaxbookspic.json?token=" + this.GLOBAL.token + "&id=" + id;
            window.open(url);
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/taxbooks/taxbookslog.vue